var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1448,
    height: 642,
    viewBox: "0 0 1448 642",
    fill: "none",
    id: "svg68",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_12906)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.986,
    cy: 514.356,
    rx: 186.518,
    ry: 94.2764,
    stroke: "black",
    id: "ellipse2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.986,
    cy: 514.356,
    rx: 177.701,
    ry: 88.2769,
    stroke: "black",
    id: "ellipse4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.358 582.247C148.005 569.826 134.397 548.88 134.397 529.047C134.397 484.003 203.025 447.487 287.681 447.487C372.338 447.487 440.965 484.003 440.965 529.047C440.965 546.164 432.402 563.383 413.072 576.1",
    stroke: "black",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.377 511.028C473.012 515.881 472.504 520.609 472.504 529.277C472.504 584.341 388.997 628.979 285.986 628.979C182.975 628.979 99.4679 584.341 99.4679 529.277C99.4679 522.064 99.2135 516.602 99.5844 510.911",
    stroke: "black",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.503 529.871C473.139 534.724 472.503 549.435 472.503 558.103C472.503 613.167 388.997 657.805 285.986 657.805C182.975 657.805 99.4676 613.167 99.4676 558.103C99.4676 550.89 99.0967 534.459 99.4675 528.769",
    stroke: "black",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83284 659.44L128.668 712.279M3.83284 659.44L113.371 596.424M3.83284 659.44L9.59747 680.465L134.875 733.052M128.668 712.279L233.742 654.264M128.668 712.279L134.875 733.052M147.975 713.241L249.511 655.966M134.875 733.052L266.146 657.066M68.2656 646.553L140.838 677.075M108.004 622.726L179.558 654.264",
    stroke: "black",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.011 520.49L627.5 426.501M581.5 335.5L397.048 438.392M631 434.501L472.386 533.022M511.899 468.574L436.952 438.392M544.795 449.689L469.848 419.507M574.298 431.715L499.351 401.533M602.5 416.307L527.553 386.125M610.5 393.001L559.553 371.351",
    stroke: "black",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.251 513.509C275.251 516.371 280.083 518.69 286.044 518.69C286.31 518.69 286.573 518.686 286.834 518.677L316.034 586.121C316.322 586.785 317.083 587.103 317.757 586.84C318.465 586.564 318.804 585.758 318.507 585.06L290.096 518.313C294.049 517.544 296.838 515.683 296.838 513.509C296.838 511.237 293.791 509.307 289.551 508.608L286.939 502.234C286.939 502.234 286.24 499.945 281.068 500.178C275.897 500.411 276.681 502.742 276.681 502.742L279.413 509.421C276.88 510.369 275.251 511.848 275.251 513.509Z",
    stroke: "black",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.484 521.635C276.15 520.08 278.192 518.766 280.971 517.999M290.801 527.83C289.511 528.073 288.107 528.207 286.638 528.207C284.689 528.207 282.854 527.972 281.25 527.558M293.971 526.923C296.45 525.92 298.025 524.419 298.025 522.741C298.025 520.629 295.529 518.797 291.875 517.887",
    stroke: "black",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.784 523.344H285.308L223.078 586.082L216.974 583.03L275.412 525.575M282.51 518.597L275.412 525.575M275.412 525.575L195.44 533.264L193.744 528.686L275.526 521.638L275.6 521.373",
    stroke: "black",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.705 497.532C405.705 498.596 404.537 499.66 402.814 499.66C401.091 499.66 399.923 498.596 399.923 497.532C399.923 496.467 401.091 495.403 402.814 495.403C404.537 495.403 405.705 496.467 405.705 497.532Z",
    stroke: "black",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.637 472.897C362.637 473.961 361.469 475.025 359.746 475.025C358.023 475.025 356.854 473.961 356.854 472.897C356.854 471.832 358.023 470.769 359.746 470.769C361.469 470.769 362.637 471.832 362.637 472.897Z",
    stroke: "black",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.764 462.723C301.764 463.787 300.596 464.851 298.873 464.851C297.15 464.851 295.981 463.787 295.981 462.723C295.981 461.659 297.15 460.595 298.873 460.595C300.596 460.595 301.764 461.659 301.764 462.723Z",
    stroke: "black",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.009 467.98C238.009 469.044 236.841 470.108 235.118 470.108C233.395 470.108 232.227 469.044 232.227 467.98C232.227 466.915 233.395 465.852 235.118 465.852C236.841 465.852 238.009 466.915 238.009 467.98Z",
    stroke: "black",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24 487.988C183.24 489.052 182.072 490.116 180.349 490.116C178.626 490.116 177.458 489.052 177.458 487.988C177.458 486.923 178.626 485.859 180.349 485.859C182.072 485.859 183.24 486.923 183.24 487.988Z",
    stroke: "black",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.671 520.511C159.671 521.575 158.503 522.639 156.78 522.639C155.057 522.639 153.889 521.575 153.889 520.511C153.889 519.447 155.057 518.383 156.78 518.383C158.503 518.383 159.671 519.447 159.671 520.511Z",
    stroke: "black",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.675 556.797C169.675 557.861 168.507 558.925 166.784 558.925C165.061 558.925 163.893 557.861 163.893 556.797C163.893 555.733 165.061 554.669 166.784 554.669C168.507 554.669 169.675 555.733 169.675 556.797Z",
    stroke: "black",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37 584.681C210.37 585.745 209.202 586.809 207.479 586.809C205.756 586.809 204.588 585.745 204.588 584.681C204.588 583.617 205.756 582.553 207.479 582.553C209.202 582.553 210.37 583.617 210.37 584.681Z",
    stroke: "black",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.533 595.914C281.533 596.979 280.365 598.043 278.642 598.043C276.919 598.043 275.751 596.979 275.751 595.914C275.751 594.85 276.919 593.786 278.642 593.786C280.365 593.786 281.533 594.85 281.533 595.914Z",
    stroke: "black",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.376 590.657C350.376 591.721 349.208 592.785 347.485 592.785C345.762 592.785 344.594 591.721 344.594 590.657C344.594 589.592 345.762 588.528 347.485 588.528C349.208 588.528 350.376 589.592 350.376 590.657Z",
    stroke: "black",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.705 565.053C405.705 566.117 404.537 567.181 402.814 567.181C401.091 567.181 399.923 566.117 399.923 565.053C399.923 563.989 401.091 562.925 402.814 562.925C404.537 562.925 405.705 563.989 405.705 565.053Z",
    stroke: "black",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.509 531.395C423.509 532.459 422.341 533.523 420.618 533.523C418.895 533.523 417.727 532.459 417.727 531.395C417.727 530.331 418.895 529.267 420.618 529.267C422.341 529.267 423.509 530.331 423.509 531.395Z",
    stroke: "black",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.5 575L743.5 653.748L499.5 175.249L858.669 9.53703L1053.38 398.5",
    stroke: "black",
    id: "path46"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1050_12906)",
    id: "g54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.23 454.66C1250.5 464.383 1168.24 487.599 1157.05 502.673C1143.06 521.517 1121.02 596.613 1124.01 608.557C1127.01 620.5 1146.03 662.041 1156.63 671.314C1167.24 680.587 1188.98 684.072 1199.99 670.633C1172.93 669.272 1182.24 645.144 1183.16 638.242C1184.07 631.339 1211.48 590.09 1226.71 568.676C1238.89 551.544 1252.93 543.687 1258.43 541.9L1360.79 512.484M1222.36 405.723L1109.12 456.229C1099.23 459.871 1079.42 472.054 1079.32 491.648M1079.32 491.648C1073.98 494.704 1066.71 498.924 1059.09 503.438M1079.32 491.648C1079.29 496.835 1078.63 504.623 1077.6 513.754M970.605 575.613C996.876 558.14 1015.86 532.462 1021.46 527.509C1026.2 523.311 1043.38 512.747 1059.09 503.438M970.605 575.613C955.549 585.628 937.954 594.598 919.404 592.126C884 587.408 900.945 541.9 924.5 517.125C942.152 498.56 958.881 476.616 980.5 456.229C1005 433.126 1014.02 425.086 1021.46 417.126C1038 399.421 1064.47 395.384 1079.32 392.293C1097.88 388.43 1187.33 368.005 1200.27 363.21C1213.2 358.415 1243.17 336.14 1284.15 379.121C1290.23 385.495 1293.49 386.916 1299 386.625C1305.88 386.262 1322.99 380.416 1338.8 395.985C1351.45 408.441 1406.31 476.393 1432.16 508.812C1452.5 549.625 1402.68 640.672 1399.5 694.625L1129.14 707.462C1120.76 704.532 1102.05 694.928 1094.26 679.947C1086.48 664.966 1073.04 643.561 1066.74 621.125C1064.45 613 1064.06 603.125 1066.74 587.408M970.605 575.613C982.486 580.744 1018.35 590.285 1066.74 587.408M1066.74 587.408C1070.12 567.483 1075.03 536.466 1077.6 513.754M1059.09 503.438C1063.14 505.899 1072.5 511.408 1077.6 513.754M1338.8 592.126C1320.37 598.874 1282.7 613.246 1279.5 616.748C1276.3 620.25 1264.12 641.54 1258.43 651.748",
    stroke: "black",
    id: "path56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs66"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_12906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1447,
    height: 642,
    fill: "white",
    transform: "translate(0.5)",
    id: "rect60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1050_12906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 461,
    fill: "white",
    transform: "translate(568.993 170.84) rotate(-26.3194)",
    id: "rect63"
  })))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "PASSPORT",
    transform: "matrix(0.8434964,-0.41803445,0.47169495,0.95177081,10.193784,368.84473)",
    id: "text2124",
    style: {
      fontSize: "69.5454px",
      lineHeight: 1.25,
      fill: "#008080",
      strokeWidth: 1.73864
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 618.95249,158.28932 q 9.73635,0 14.18726,3.82499 4.4509,3.825 4.4509,10.77954 0,4.10318 -1.87772,7.71954 -1.80818,3.54682 -6.18954,5.77227 -4.31182,2.22545 -11.75318,2.22545 h -5.70272 v 19.33362 h -6.25909 v -49.65541 z m -0.55637,5.35499 h -6.32863 v 19.6118 h 5.00727 q 7.09363,0 10.5709,-2.29499 3.47727,-2.295 3.47727,-7.78909 0,-4.79863 -3.06,-7.16318 -3.05999,-2.36454 -9.66681,-2.36454 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 675.56247,207.94473 -5.98091,-15.36953 h -19.68135 l -5.91136,15.36953 h -6.32863 l 19.40317,-49.86405 h 5.63318 l 19.33362,49.86405 z M 662.1402,171.98976 q -0.20863,-0.55636 -0.69545,-2.01682 -0.48682,-1.46045 -0.97364,-2.99045 -0.41727,-1.59954 -0.69545,-2.43409 -0.48682,2.15591 -1.11273,4.24227 -0.62591,2.01682 -1.04318,3.19909 l -5.63318,15.02181 h 15.71726 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.01152,194.66156 q 0,6.60681 -4.79863,10.29272 -4.79863,3.68591 -12.93544,3.68591 -4.17273,0 -7.71954,-0.62591 -3.54682,-0.62591 -5.91136,-1.73864 v -5.9809 q 2.50363,1.11272 6.18954,2.01682 3.75545,0.90409 7.71954,0.90409 5.56363,0 8.34545,-2.15591 2.85136,-2.15591 2.85136,-5.84182 0,-2.43409 -1.04318,-4.10317 -1.04318,-1.66909 -3.61636,-3.06 -2.50364,-1.46046 -7.02409,-3.06 -6.32863,-2.295 -9.59727,-5.63318 -3.19908,-3.33818 -3.19908,-9.11045 0,-3.96408 2.01681,-6.7459 2.01682,-2.85136 5.56363,-4.38136 3.61637,-1.53 8.27591,-1.53 4.10318,0 7.5109,0.765 3.40773,0.765 6.18954,2.01682 l -1.94727,5.35499 q -2.57318,-1.11272 -5.63318,-1.87772 -2.99045,-0.765 -6.25908,-0.765 -4.65955,0 -7.02409,2.01681 -2.36454,1.94728 -2.36454,5.21591 0,2.50363 1.04318,4.17272 1.04318,1.66909 3.40772,2.99046 2.36455,1.32136 6.39818,2.85136 4.38136,1.59954 7.37181,3.47727 3.06,1.80818 4.59,4.38136 1.59954,2.57318 1.59954,6.46772 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 755.19193,194.66156 q 0,6.60681 -4.79863,10.29272 -4.79864,3.68591 -12.93545,3.68591 -4.17272,0 -7.71954,-0.62591 -3.54681,-0.62591 -5.91136,-1.73864 v -5.9809 q 2.50364,1.11272 6.18954,2.01682 3.75545,0.90409 7.71954,0.90409 5.56363,0 8.34545,-2.15591 2.85136,-2.15591 2.85136,-5.84182 0,-2.43409 -1.04318,-4.10317 -1.04318,-1.66909 -3.61636,-3.06 -2.50363,-1.46046 -7.02409,-3.06 -6.32863,-2.295 -9.59726,-5.63318 -3.19909,-3.33818 -3.19909,-9.11045 0,-3.96408 2.01682,-6.7459 2.01681,-2.85136 5.56363,-4.38136 3.61636,-1.53 8.2759,-1.53 4.10318,0 7.51091,0.765 3.40772,0.765 6.18954,2.01682 l -1.94727,5.35499 q -2.57318,-1.11272 -5.63318,-1.87772 -2.99045,-0.765 -6.25909,-0.765 -4.65954,0 -7.02408,2.01681 -2.36455,1.94728 -2.36455,5.21591 0,2.50363 1.04318,4.17272 1.04318,1.66909 3.40773,2.99046 2.36454,1.32136 6.39817,2.85136 4.38137,1.59954 7.37182,3.47727 3.06,1.80818 4.58999,4.38136 1.59955,2.57318 1.59955,6.46772 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 778.35054,158.28932 q 9.73636,0 14.18726,3.82499 4.45091,3.825 4.45091,10.77954 0,4.10318 -1.87773,7.71954 -1.80818,3.54682 -6.18954,5.77227 -4.31181,2.22545 -11.75317,2.22545 h -5.70272 v 19.33362 h -6.25909 v -49.65541 z m -0.55636,5.35499 h -6.32863 v 19.6118 h 5.00727 q 7.09363,0 10.5709,-2.29499 3.47727,-2.295 3.47727,-7.78909 0,-4.79863 -3.06,-7.16318 -3.06,-2.36454 -9.66681,-2.36454 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 850.60818,183.04748 q 0,7.71954 -2.64272,13.49181 -2.57318,5.70272 -7.65,8.90181 -5.07681,3.19909 -12.58772,3.19909 -7.71954,0 -12.8659,-3.19909 -5.07681,-3.19909 -7.58044,-8.97136 -2.50364,-5.77227 -2.50364,-13.49181 0,-7.64999 2.50364,-13.35271 2.50363,-5.70273 7.58044,-8.90182 5.14636,-3.19908 12.93545,-3.19908 7.44136,0 12.51817,3.19908 5.07682,3.12955 7.65,8.90182 2.64272,5.70272 2.64272,13.42226 z m -39.22361,0 q 0,9.38863 3.96409,14.81317 3.96409,5.355 12.37908,5.355 8.48454,0 12.37909,-5.355 3.89454,-5.42454 3.89454,-14.81317 0,-9.38863 -3.89454,-14.67408 -3.89455,-5.355 -12.30954,-5.355 -8.41499,0 -12.44863,5.355 -3.96409,5.28545 -3.96409,14.67408 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 875.29681,158.28932 q 9.24954,0 13.6309,3.54681 4.45091,3.47727 4.45091,10.5709 0,3.96409 -1.46046,6.60682 -1.46045,2.64272 -3.75545,4.24226 -2.22545,1.53 -4.72909,2.43409 l 13.6309,22.25453 h -7.30226 L 877.7309,187.42884 h -9.87545 v 20.51589 h -6.25908 v -49.65541 z m -0.34772,5.42454 h -7.09364 v 18.42953 h 7.44136 q 6.05045,0 8.83227,-2.36455 2.78181,-2.43408 2.78181,-7.09363 0,-4.86817 -2.9209,-6.88499 -2.92091,-2.08636 -9.0409,-2.08636 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 920.57083,207.94473 h -6.25909 V 163.7834 h -15.50862 v -5.49408 h 37.20679 v 5.49408 h -15.43908 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13387"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "PASSPORT",
    transform: "matrix(0.8434964,-0.41803445,0.47169495,0.95177081,124.15285,603.88093)",
    id: "text2124-8",
    style: {
      fontSize: "69.5454px",
      lineHeight: 1.25,
      fill: "#008080",
      strokeWidth: 1.73864
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 618.95249,158.28932 q 9.73635,0 14.18726,3.82499 4.4509,3.825 4.4509,10.77954 0,4.10318 -1.87772,7.71954 -1.80818,3.54682 -6.18954,5.77227 -4.31182,2.22545 -11.75318,2.22545 h -5.70272 v 19.33362 h -6.25909 v -49.65541 z m -0.55637,5.35499 h -6.32863 v 19.6118 h 5.00727 q 7.09363,0 10.5709,-2.29499 3.47727,-2.295 3.47727,-7.78909 0,-4.79863 -3.06,-7.16318 -3.05999,-2.36454 -9.66681,-2.36454 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13373-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 675.56247,207.94473 -5.98091,-15.36953 h -19.68135 l -5.91136,15.36953 h -6.32863 l 19.40317,-49.86405 h 5.63318 l 19.33362,49.86405 z M 662.1402,171.98976 q -0.20863,-0.55636 -0.69545,-2.01682 -0.48682,-1.46045 -0.97364,-2.99045 -0.41727,-1.59954 -0.69545,-2.43409 -0.48682,2.15591 -1.11273,4.24227 -0.62591,2.01682 -1.04318,3.19909 l -5.63318,15.02181 h 15.71726 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13375-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 717.01152,194.66156 q 0,6.60681 -4.79863,10.29272 -4.79863,3.68591 -12.93544,3.68591 -4.17273,0 -7.71954,-0.62591 -3.54682,-0.62591 -5.91136,-1.73864 v -5.9809 q 2.50363,1.11272 6.18954,2.01682 3.75545,0.90409 7.71954,0.90409 5.56363,0 8.34545,-2.15591 2.85136,-2.15591 2.85136,-5.84182 0,-2.43409 -1.04318,-4.10317 -1.04318,-1.66909 -3.61636,-3.06 -2.50364,-1.46046 -7.02409,-3.06 -6.32863,-2.295 -9.59727,-5.63318 -3.19908,-3.33818 -3.19908,-9.11045 0,-3.96408 2.01681,-6.7459 2.01682,-2.85136 5.56363,-4.38136 3.61637,-1.53 8.27591,-1.53 4.10318,0 7.5109,0.765 3.40773,0.765 6.18954,2.01682 l -1.94727,5.35499 q -2.57318,-1.11272 -5.63318,-1.87772 -2.99045,-0.765 -6.25908,-0.765 -4.65955,0 -7.02409,2.01681 -2.36454,1.94728 -2.36454,5.21591 0,2.50363 1.04318,4.17272 1.04318,1.66909 3.40772,2.99046 2.36455,1.32136 6.39818,2.85136 4.38136,1.59954 7.37181,3.47727 3.06,1.80818 4.59,4.38136 1.59954,2.57318 1.59954,6.46772 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13377-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 755.19193,194.66156 q 0,6.60681 -4.79863,10.29272 -4.79864,3.68591 -12.93545,3.68591 -4.17272,0 -7.71954,-0.62591 -3.54681,-0.62591 -5.91136,-1.73864 v -5.9809 q 2.50364,1.11272 6.18954,2.01682 3.75545,0.90409 7.71954,0.90409 5.56363,0 8.34545,-2.15591 2.85136,-2.15591 2.85136,-5.84182 0,-2.43409 -1.04318,-4.10317 -1.04318,-1.66909 -3.61636,-3.06 -2.50363,-1.46046 -7.02409,-3.06 -6.32863,-2.295 -9.59726,-5.63318 -3.19909,-3.33818 -3.19909,-9.11045 0,-3.96408 2.01682,-6.7459 2.01681,-2.85136 5.56363,-4.38136 3.61636,-1.53 8.2759,-1.53 4.10318,0 7.51091,0.765 3.40772,0.765 6.18954,2.01682 l -1.94727,5.35499 q -2.57318,-1.11272 -5.63318,-1.87772 -2.99045,-0.765 -6.25909,-0.765 -4.65954,0 -7.02408,2.01681 -2.36455,1.94728 -2.36455,5.21591 0,2.50363 1.04318,4.17272 1.04318,1.66909 3.40773,2.99046 2.36454,1.32136 6.39817,2.85136 4.38137,1.59954 7.37182,3.47727 3.06,1.80818 4.58999,4.38136 1.59955,2.57318 1.59955,6.46772 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13379-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 778.35054,158.28932 q 9.73636,0 14.18726,3.82499 4.45091,3.825 4.45091,10.77954 0,4.10318 -1.87773,7.71954 -1.80818,3.54682 -6.18954,5.77227 -4.31181,2.22545 -11.75317,2.22545 h -5.70272 v 19.33362 h -6.25909 v -49.65541 z m -0.55636,5.35499 h -6.32863 v 19.6118 h 5.00727 q 7.09363,0 10.5709,-2.29499 3.47727,-2.295 3.47727,-7.78909 0,-4.79863 -3.06,-7.16318 -3.06,-2.36454 -9.66681,-2.36454 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13381-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 850.60818,183.04748 q 0,7.71954 -2.64272,13.49181 -2.57318,5.70272 -7.65,8.90181 -5.07681,3.19909 -12.58772,3.19909 -7.71954,0 -12.8659,-3.19909 -5.07681,-3.19909 -7.58044,-8.97136 -2.50364,-5.77227 -2.50364,-13.49181 0,-7.64999 2.50364,-13.35271 2.50363,-5.70273 7.58044,-8.90182 5.14636,-3.19908 12.93545,-3.19908 7.44136,0 12.51817,3.19908 5.07682,3.12955 7.65,8.90182 2.64272,5.70272 2.64272,13.42226 z m -39.22361,0 q 0,9.38863 3.96409,14.81317 3.96409,5.355 12.37908,5.355 8.48454,0 12.37909,-5.355 3.89454,-5.42454 3.89454,-14.81317 0,-9.38863 -3.89454,-14.67408 -3.89455,-5.355 -12.30954,-5.355 -8.41499,0 -12.44863,5.355 -3.96409,5.28545 -3.96409,14.67408 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13383-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 875.29681,158.28932 q 9.24954,0 13.6309,3.54681 4.45091,3.47727 4.45091,10.5709 0,3.96409 -1.46046,6.60682 -1.46045,2.64272 -3.75545,4.24226 -2.22545,1.53 -4.72909,2.43409 l 13.6309,22.25453 h -7.30226 L 877.7309,187.42884 h -9.87545 v 20.51589 h -6.25908 v -49.65541 z m -0.34772,5.42454 h -7.09364 v 18.42953 h 7.44136 q 6.05045,0 8.83227,-2.36455 2.78181,-2.43408 2.78181,-7.09363 0,-4.86817 -2.9209,-6.88499 -2.92091,-2.08636 -9.0409,-2.08636 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13385-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 920.57083,207.94473 h -6.25909 V 163.7834 h -15.50862 v -5.49408 h 37.20679 v 5.49408 h -15.43908 z",
    style: {
      fill: "#008080",
      stroke: "#000000"
    },
    id: "path13387-8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocImg);
export default __webpack_public_path__ + "static/media/doc-img.0cbe5d4e1189710108bd05052b21b5aa.svg";
export { ForwardRef as ReactComponent };